import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {getPublicFile} from 'helpers/envHelper'
import styled from 'styled-components'
import useHealthCenterBrainFunctionMappingStyles from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Style'
import TableFiguresByPart from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tableFiguresByPart'
import useLangEn from 'hooks/useLangEn'
import {useAppSelector} from 'hooks'
import {
  getCurrentLanguageReport,
  selectLanguageReport,
} from 'features/languageReport/languageReportSlice'

export const PageWrap = styled.div`
  background: White;
`

export const PageContent = styled.div`
  width: 1160px;
`

export const CardContent = styled.div`
  font-size: 14px;
`

export const FlexBox = styled.div`
  display: flex;
  padding: 0 15px;
  justify-content: space-between;
`
const getHealthReportReportImage = getPublicFile('images/health_center_report')

interface BrainFunctionMappingProps {
  agingRoiScore: Record<string, any>
}

const getNumber = (value: number | string) => {
  if (!Number.isNaN(Number(value))) return Math.floor(Number(value))
  return 0
}

function TablePrintF8({agingRoiScore}: BrainFunctionMappingProps) {
  const {t} = useTranslation()
  const isEn = useLangEn()
  const classes = useHealthCenterBrainFunctionMappingStyles()
  const languageReport = useAppSelector((state) =>
    selectLanguageReport(state.languageReport),
  )
  const currentLanguagueReport = getCurrentLanguageReport(languageReport, 'es')
  const headTable = [
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[0] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[1] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[2] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[3] || '',
    currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
      .score_table.headers[4] || '',
  ]

  const bodyTable2 = useMemo(
    () => [
      {
        data: [
          {
            header: [
              {
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[5].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .frontal.score_table.rows[5].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[5].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainF8.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[5].functions,

          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[5].symptoms,
          [getNumber(agingRoiScore?.Medial_Orbitofrontal_LH)],
          [getNumber(agingRoiScore?.Medial_Orbitofrontal_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'F9.',
                // content: 'Lateral Orbitofrontal',
                // note: t('ILateralF9'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[6].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .frontal.score_table.rows[6].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[6].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainF9.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[6].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[6].symptoms,
          [getNumber(agingRoiScore?.Lateral_Orbitofrontal_LH)],
          [getNumber(agingRoiScore?.Lateral_Orbitofrontal_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'F10.',
                // content: 'Precentral',
                // note: t('IAnteriorF10'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[7].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .frontal.score_table.rows[7].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[7].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainF10.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[7].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[7].symptoms,
          [getNumber(agingRoiScore?.Precentral_LH)],
          [getNumber(agingRoiScore?.Precentral_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'F11.',
                // content: 'Paracentral',
                // note: t('IAtrialF11'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[8].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .frontal.score_table.rows[8].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[8].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainF11.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[8].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[8].symptoms,
          [getNumber(agingRoiScore?.Paracentral_LH)],
          [getNumber(agingRoiScore?.Paracentral_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'F12.',
                // content: 'Rostral Anterior Cingulate',
                // note: t('IAnteriorF12'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[9].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .frontal.score_table.rows[9].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[9].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainF12.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[9].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[9].symptoms,
          [getNumber(agingRoiScore?.Rostral_Anterior_Cingulate_LH)],
          [getNumber(agingRoiScore?.Rostral_Anterior_Cingulate_RH)],
        ],
        background: 'White',
      },
      {
        data: [
          {
            header: [
              {
                // key: 'F13.',
                // content: 'Caudal Anterior Cingulate',
                // note: t('IAnteriorF13'),
                key: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[10].rois[0].code,
                content:
                  currentLanguagueReport?.health?.brain_mapping.advanced.section
                    .frontal.score_table.rows[10].rois[0].name,
                note: currentLanguagueReport?.health?.brain_mapping.advanced
                  .section.frontal.score_table.rows[10].rois[0].translation,
              },
            ],
            image: getHealthReportReportImage('brainF13.png'),
          },
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[10].functions,
          currentLanguagueReport?.health?.brain_mapping.advanced.section.frontal
            .score_table.rows[10].symptoms,
          [getNumber(agingRoiScore?.Caudal_Anterior_Cingulate_LH)],
          [getNumber(agingRoiScore?.Caudal_Anterior_Cingulate_RH)],
        ],
        background: 'White',
      },
    ],
    [isEn, currentLanguagueReport],
  )

  return (
    <div className={classes.brainFunctionMapping}>
      <PageWrap>
        <PageContent>
          <div className={classes.marginBottom60}>
            <TableFiguresByPart
              head={headTable}
              body={bodyTable2 as any}
              isLocalLanguage={false}
            />
          </div>
        </PageContent>
      </PageWrap>
    </div>
  )
}

export default TablePrintF8
